import { useEffect, useRef, useState } from 'react';

export const useTemporaryClass = (timeout = 3800) => {
  const [flashClassName, setFlashClassName] = useState('');
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const triggerClass = (name: string) => {
    if (timerRef.current) clearTimeout(timerRef.current);

    setFlashClassName(name);

    timerRef.current = setTimeout(() => {
      setFlashClassName('');
      timerRef.current = null;
    }, timeout);
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, []);

  return { flashClassName, triggerClass };
};
